import axios from 'axios';

function base_url(site_path, id) {
  if (id !== undefined) {
    return `${site_path}/risk_matrix/${id}/`;
  }
  return `${site_path}/risk_matrix/`;
}


export default {
  get: async (site_path, id) => {
    const response = await axios.get(base_url(site_path, id));
    return response.data;
  },

  list: async (site_path) => {
    const response = await axios.get(base_url(site_path));
    return response.data;
  },

  post: async (site_path, data) => {
    const response = await axios.post(base_url(site_path), data);
    return response.data;
  },

  put: async (site_path, id, data) => {
    const response = await axios.put(base_url(site_path, id), data);
    return response.data;
  },

  delete: async (site_path, id) => {
    const response = await axios.delete(base_url(site_path, id));
    return response.data;
  },
};
